import { Environment } from '@react-three/drei';
import { useRef } from 'react';
import { useGLTF } from '@react-three/drei';
import React from 'react';

export default function Scene() {
	const model = useGLTF('/b1.glb'); 
	const modelRef = useRef(null);
	return (
		<>
			<Environment preset="warehouse" />
			{/* <OrbitControls makeDefault /> */}
			<primitive object={model.scene} ref={modelRef} />
		</>
	);
}